import { css } from '@emotion/react'
import { memo } from 'react'
import useMedia from '~/hooks/useMedia'
import { fill_horizontal_all_center, flex } from '~/modules/AppLayout/FlexGridCss'
import { UserAvatarAsDialogButton } from '~/modules/auth/components/UserAvatarAsDialogButton'
import { Preset_Topbar } from '~/pages/heineken_template/_preset/preset_Topbar'
import { ChartingServerSwitch } from '~/modules/SDK/chart4/components/ChartingServerSwitch'
import { mvp888Stock_agentStore } from './mvp888Stock_store'
import { useMount } from 'react-use'
import dayAPI from '~/utils/dayAPI'
import { useDatePick } from '~/modules/screener/useDatePick'
import { store } from '~/pages/heineken_template/_private/store'

export const Mvp888Stock_Topbar = memo<ReactProps>(function Lung88988Stock_Topbar() {
  const { isPc } = useMedia()

  const lastTradeDate = useDatePick()
  useMount(() => {
    mvp888Stock_agentStore.stockPickedDate = dayAPI(lastTradeDate)
  })

  return (
    <div>
      {isPc && (
        <div
          css={css`
            ${flex.h.allCenter}
            justify-content: end;
            background-color: #273455;
            width: 100%;
            height: 100%;
          `}
        >
          <ChartingServerSwitch
            charting={store.charting}
            css={css`
              background-color: #eeeeee;
            `}
          />
          <UserAvatarAsDialogButton />
        </div>
      )}
      {!isPc && (
        <Preset_Topbar
          css={css`
            background-color: #273455;
          `}
          showLeftBurger
          showRightBurger
          componentsInRight={
            <div css={fill_horizontal_all_center}>
              <ChartingServerSwitch
                charting={store.charting}
                css={css`
                  background-color: #eeeeee;
                `}
              />
              <UserAvatarAsDialogButton />
            </div>
          }
        ></Preset_Topbar>
      )}
    </div>
  )
})
